import React, { useEffect, useState } from 'react';
import { styles } from './ProductCardActions.css';
import { getProductCardActionLabel } from '../utils/getProductCardActionLabel';
import { ActionButton } from '../../ActionButton';
import { CartActionState } from '../../CartProvider/types';
import { ProductCardVariant } from '../ProductCard';

const CONFIRMATION_DURATION_MS = 2000;

export type ProductCardActionsProps = {
  variant: ProductCardVariant;
  label: string;
  isLoading?: boolean;
  type?: 'primary' | 'secondary' | 'action';
  onAction: (e?: any) => Promise<boolean> | void;
  testId?: string;
  isConfirmationEnabled?: boolean;
  shouldRemainInAddedState?: boolean;
};

export const ProductCardActions = ({
  variant,
  label,
  isLoading,
  type = 'primary',
  onAction,
  testId,
  isConfirmationEnabled = false,
  shouldRemainInAddedState = true,
}: ProductCardActionsProps) => {
  const [shouldShowConfirmation, setShouldShowConfirmation] = useState<boolean>(false);

  const handleAction = async (e: any) => {
    const success = await onAction(e);
    if (isConfirmationEnabled && success) {
      setShouldShowConfirmation(true);
    }
  };

  useEffect(() => {
    if (!shouldShowConfirmation || shouldRemainInAddedState) return;
    const timeout = setTimeout(() => setShouldShowConfirmation(false), CONFIRMATION_DURATION_MS);
    return () => clearTimeout(timeout);
  }, [shouldShowConfirmation]);

  return (
    <div className={styles.container({ variant })}>
      <ActionButton
        data-testid={testId}
        onClick={handleAction}
        label={getProductCardActionLabel(label)}
        isLoading={isLoading}
        state={shouldShowConfirmation ? CartActionState.Complete : CartActionState.Default}
        actionFinishedLabel="Added!"
        type={type}
        size={variant === 'minified' ? 'sm' : undefined}
        dataTestId={testId}
      />
    </div>
  );
};
